package pl.decks.personal.components.widgets.sitckybg

import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.vh
import pl.decks.personal.styles.SiteLayout

object StickyBackgroundStylesheet {
    object Vars {
        val bgHeight by StyleVariable<CSSLengthOrPercentageNumericValue>(100.vh)
    }

    val Container = CssStyle.base {
        Modifier
            .position(Position.Sticky)
            .top(SiteLayout.Fraction.none)
            .left(SiteLayout.Fraction.none)
            .height(Vars.bgHeight.value())
            .minHeight(Vars.bgHeight.value())
            .fillMaxWidth()
    }
}
